const SEARCHBAR_TOGGLE_SELECTOR = '.search-bar__toggle';
const SEARCHBAR_IS_CLOSED_ATTRIBUTE = 'is-closed';

/**
 * Search bar element for the solr search
 *  - toggle open / close on toggle click
 */
class SearchBar {
    constructor(el) {
        this.el = el;
        this.toggle = this.el.querySelector(SEARCHBAR_TOGGLE_SELECTOR);
        this._isClosed = this.el.hasAttribute(SEARCHBAR_IS_CLOSED_ATTRIBUTE);

        if (!this.toggle) return;

        this.toggle.addEventListener('click', () => {
            this._isClosed = !this._isClosed;
            this._updateSearchBarUI();
        });

        this._updateSearchBarUI();
    }

    /**
     * update the search bar UI by adding / removing the attribute according to the _isClosed state
     * @private
     */
    _updateSearchBarUI() {
        this._isClosed
            ? this.el.setAttribute(SEARCHBAR_IS_CLOSED_ATTRIBUTE, '')
            : this.el.removeAttribute(SEARCHBAR_IS_CLOSED_ATTRIBUTE);
    }
}

/**
 * Get all search-bar elements on the page and initialize the SearchBar class for each of them
 */
export function initSearchBar() {
    const searchBars = document.querySelectorAll('.search-bar');
    if (!searchBars) return;

    searchBars.forEach((searchBar) => {
        searchBar.searchBar = new SearchBar(searchBar);
    })
}
